import React, { ChangeEvent, RefObject, useRef } from 'react'

import { HiOutlinePhotograph } from 'react-icons/hi'

import { Button, Text } from '@chakra-ui/react'

import { ALLOWED_IMAGE_EXTENSIONS } from '../utils/constants'

interface AttachImagesButtonIProps {
  allowedExtensions?: string
  handleFileSelect: (event: ChangeEvent<HTMLInputElement>) => void
  maxFiles: number
  selectedFiles: File[]
}

const getButtonLabel = (count: number, max: number): string => {
  return count === 0 ? 'Attach Images' : `${count}/${max} images selected`
}

export const AttachImagesButton = ({
  allowedExtensions = ALLOWED_IMAGE_EXTENSIONS.join(','),
  handleFileSelect,
  maxFiles,
  selectedFiles,
}: AttachImagesButtonIProps) => {
  const fileInputRef: RefObject<HTMLInputElement> = useRef()
  const openFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const isDisabled = selectedFiles.length >= maxFiles

  return (
    <>
      <Button
        _hover={{ borderColor: '#9FB8E5' }}
        borderColor='#9FB8E5'
        borderRadius='md'
        borderWidth='2px'
        data-testid='createIncidentModal_attachImagesButton'
        height='10'
        isDisabled={isDisabled}
        leftIcon={<HiOutlinePhotograph size={18} />}
        onClick={openFileDialog}
        variant='outline'
        width='full'
      >
        <Text fontSize='sm' fontWeight='500'>
          {getButtonLabel(selectedFiles.length, maxFiles)}
        </Text>
      </Button>
      <input
        accept={allowedExtensions}
        aria-label='Select images to attach'
        className='hidden'
        data-testid='createIncidentModal_imageInput'
        multiple
        onChange={handleFileSelect}
        onClick={(event) => {
          if (event.currentTarget) {
            event.currentTarget.value = ''
          }
        }}
        ref={fileInputRef}
        type='file'
      />
    </>
  )
}
